import { render, staticRenderFns } from "./video-courses.vue?vue&type=template&id=8774b220&"
import script from "./video-courses.vue?vue&type=script&lang=js&"
export * from "./video-courses.vue?vue&type=script&lang=js&"
import style0 from "./video-courses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports